// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3AEMg","label":"Radio_label__nSUbo","checkMark":"Radio_checkMark__qUR9D","disabled":"Radio_disabled__3BcoN"};